
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://www.cherokeeyouthwarriors.com';

const officersSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Meet Our Officers | Cherokee Youth Warriors',
  description: 'Meet the dedicated volunteer officers leading Cherokee Youth Football & Cheer in Canton, GA.',
  url: `${siteUrl}/officers`,
  isPartOf: { '@type': 'WebSite', url: siteUrl, name: 'Cherokee Youth Warriors' },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'Officers', item: `${siteUrl}/officers` },
    ],
  },
};

const officers = [
  {
    name: 'JD Hurd',
    title: 'Football President',
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/32dfb1fb181a86b6035f426f8d16e26b.jpeg',
  },
  {
    name: 'Paige Dickens',
    title: 'Cheer President',
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/e47bf5e7ba9270f66e1ae1babb128b1a.jpeg',
  },
  {
    name: 'Josh Bagby',
    title: 'Football Vice President',
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/989adf79f92bac04e7bb8b49ac0b18de.jpeg',
  },
  {
    name: 'Steve Canty',
    title: 'Safety Director',
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/8d197caebd69e0245870106cb7d27406.jpeg',
  },
];

export default function OfficersPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Meet Our Officers | Cherokee Youth Warriors Canton GA"
        description="Meet the dedicated volunteer officers leading Cherokee Youth Football & Cheer in Canton, GA — building character and community one season at a time."
        keywords="Cherokee Warriors officers, youth football leadership Canton GA, cheer president, football president"
        canonical={`${siteUrl}/officers`}
        schemaJson={officersSchema}
      />
      <Header />
      <main className="pt-28 pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="font-sans text-sm font-semibold text-warrior-red tracking-widest uppercase mb-3">
              Leadership
            </p>
            <h1 className="font-display text-5xl lg:text-6xl text-warrior-black mb-4">
              MEET OUR OFFICERS
            </h1>
            <p className="font-sans text-base text-gray-600 max-w-xl mx-auto leading-relaxed">
              The Cherokee Youth Football &amp; Cheer organization is led by a dedicated group of volunteers committed to building character and community in Canton, GA.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {officers.map((officer) => (
              <div
                key={officer.name}
                className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300"
              >
                <div className="w-full h-72 overflow-hidden">
                  <img
                    src={officer.image}
                    alt={officer.name}
                    title={`${officer.name} - ${officer.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6 border-t-4 border-warrior-red">
                  <h2 className="font-display text-2xl text-warrior-black leading-tight mb-1">
                    {officer.name}
                  </h2>
                  <p className="font-sans text-sm text-gray-500 font-medium">
                    {officer.title}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-20 bg-warrior-gray rounded-3xl p-10 text-center">
            <h3 className="font-display text-3xl text-warrior-black mb-3">HAVE A QUESTION FOR OUR TEAM?</h3>
            <p className="font-sans text-sm text-gray-600 mb-6">
              Reach out to us at{' '}
              <a href="mailto:contact@cherokeeyouth.com" className="text-warrior-red font-semibold hover:underline cursor-pointer">
                contact@cherokeeyouth.com
              </a>{' '}
              or use the contact form below.
            </p>
            <a
              href="/#contact"
              className="inline-block bg-warrior-red text-white font-sans font-bold text-sm px-8 py-3 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              CONTACT US
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
